import { asError } from "./helpers/asError";

/**
 * Represents an error that may be wrapping another error.
 */
export abstract class MabyeWrappedError extends Error {
  wrappedError?: Error;

  constructor(message: string);
  constructor(wrappedError: Error);
  constructor(messageOrError: string | Error) {
    if (messageOrError instanceof MabyeWrappedError) {
      // If we're already the exact error type we're trying to create
      // just return the existing instance.
      if (new.target.prototype === Object.getPrototypeOf(messageOrError)) {
        return messageOrError;
      }
      // If we're wrapping an already wrapped error, but of a different
      // subclass, exctract the root error and wrap that instead.
      if (messageOrError.wrappedError) {
        messageOrError = messageOrError.wrappedError;
      }
    }
    if (typeof messageOrError === "string") {
      super(messageOrError);
    }
    if (!(messageOrError instanceof Error)) {
      messageOrError = asError(messageOrError);
    }
    if (messageOrError instanceof Error) {
      super(messageOrError.message);
      this.name = messageOrError.name;
      if (messageOrError.stack) this.stack = messageOrError.stack;
      this.wrappedError = messageOrError;
    }
  }
}
